import React from 'react';
import {
  useSalesforceContactRecordTypeByRecordTypeIdQuery,
  SalesforceContactField,
} from 'api';
import useSearchParams from '../../../../../useSearchParams';
import {Listbox} from '@headlessui/react';
import ArrowDownIcon from './ArrowDownIcon';

type CustomizeItemFilterItem = {
  salesforceContactFieldId: string;
  index: number;
};

export default ({salesforceContactFieldId, index}: CustomizeItemFilterItem) => {
  const {query, setQuery} = useSearchParams();
  const {
    data: {
      salesforceContactRecordTypeByRecordTypeId: {
        salesforceContactFields = [],
      } = {},
    } = {},
  } = useSalesforceContactRecordTypeByRecordTypeIdQuery({
    variables: {
      salesforceContactRecordTypeId: query.salesforceContactRecordTypeId,
    },
    skip: !query.salesforceContactRecordTypeId,
  });

  const selectedFields = () => {
    return query.salesforceContactSearchConditions.map(
      (condition) => condition['salesforce_contact_field_id'],
    );
  };

  const selectedItem = (id: string): SalesforceContactField => {
    return salesforceContactFields.find(
      (salesforceContactField) => salesforceContactField.id === id,
    );
  };

  const customizeItems = React.useMemo(() => {
    return salesforceContactFields.filter(
      (item) =>
        (item.fieldType === 'select' ||
          item.fieldType === 'multi_select' ||
          item.fieldType === 'checkbox') &&
        item.fieldName.endsWith('__c') &&
        !selectedFields().includes(item.id),
    );
  }, [salesforceContactFields]);

  return (
    <div className="relative">
      <Listbox
        value={salesforceContactFieldId ?? ''}
        onChange={(value) => {
          setQuery({
            ...query,
            salesforceContactSearchConditions: [
              ...query.salesforceContactSearchConditions.slice(0, index),
              {
                salesforce_contact_field_id: value,
                field_type: selectedItem(value)?.fieldType,
              },
              ...query.salesforceContactSearchConditions.slice(index + 1),
            ],
          });
        }}>
        <Listbox.Button className="relative px-3 text-left focus:outline-none flex items-center border rounded w-80 h-8 bg-white border-[#d9d9d9] justify-between truncate">
          <span>{selectedItem(salesforceContactFieldId)?.label}</span>
          <ArrowDownIcon />
        </Listbox.Button>
        <Listbox.Options className="absolute">
          {customizeItems.map((salesforceContactField) => (
            <Listbox.Option
              className={({active}) =>
                `relative select-none py-2 px-3 cursor-pointer w-80 h-8 pr-10 truncate z-20 ${
                  active ? 'bg-gray-100' : 'bg-white'
                }`
              }
              key={salesforceContactField.id}
              value={salesforceContactField.id}>
              {salesforceContactField.label}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </Listbox>
    </div>
  );
};
